import keycloak from './keycloak';

class KeycloakService {
  private initialized = false;
  private initPromise: Promise<boolean> | null = null;

  async init(): Promise<boolean> {
    if (this.initialized) {
      return keycloak.authenticated || false;
    }

    if (this.initPromise) {
      return this.initPromise;
    }

    this.initPromise = keycloak.init({
      onLoad: 'check-sso',
      checkLoginIframe: false,
      pkceMethod: 'S256'
    });

    try {
      const authenticated = await this.initPromise;
      this.initialized = true;
      return authenticated;
    } catch (error) {
      this.initPromise = null;
      throw error;
    }
  }

  get isInitialized() {
    return this.initialized;
  }

  get isAuthenticated() {
    return this.initialized && (keycloak.authenticated || false);
  }

  get token() {
    if (!this.initialized) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Keycloak não inicializado ao acessar token');
      }
      return null;
    }
    return keycloak.token;
  }

  isTokenValid(minValidity: number = 5): boolean {
    if (!this.initialized) {
      return false;
    }

    // Usar a função built-in do Keycloak para verificar validade
    return keycloak.isTokenExpired(minValidity) === false;
  }

  get tokenParsed() {
    if (!this.initialized) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Keycloak não inicializado ao acessar tokenParsed');
      }
      return null;
    }
    return keycloak.tokenParsed;
  }

  login(redirectUri?: string) {
    if (!this.initialized) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Tentativa de login antes da inicialização do Keycloak');
      }
    }

    const options: any = {
      pkceMethod: 'S256'
    };
    if (redirectUri) {
      options.redirectUri = `${window.location.origin}${redirectUri}`;
    }

    return keycloak.login(options);
  }

  logout() {
    // Reset do estado sempre, independente do resultado
    this.initialized = false;
    this.initPromise = null;

    return keycloak.logout({
      redirectUri: window.location.origin
    });
  }
}

export default new KeycloakService();